import { createApi } from "@reduxjs/toolkit/query/react";
import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { baseQueryAdminWithAuth } from "../api";
import type { ListAppLogsRequest, ListAppLogsResponse } from "../../contracts";

export const adminAppLogApi = createApi({
    reducerPath: "adminAppLogApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listAppLogs: builder.query<ListAppLogsResponse, ListAppLogsRequest>({
            query: body => ({
                url: `applog/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        }),
        clearLog: builder.mutation<void, void>({
            query: () => ({
                url: "applog/clear",
                method: "POST"
            })
        })
    })
});

export const {
    useListAppLogsQuery,
    useLazyListAppLogsQuery,
    useClearLogMutation
} = adminAppLogApi;
